<template>
  <div :class="classes">
    <div class="message__content">
      <slot>
        <div v-if="isHtml" v-html="text" />
        <div v-else>
          <div v-if="title" class="message__title">{{ title }}</div>
          <div class="message__text">{{ text }}</div>
        </div>
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OvpMessage',

  props: {
    text: {
      type: String,
      default: '',
    },

    title: {
      type: String,
      default: '',
    },

    severity: {
      type: String,
      default: 'info',
    },

    isHtml: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    classes() {
      const { severity } = this
      return ['message', `message--${severity}`]
    },
  },
}
</script>

<style scoped>
.message {
  font-family: Open Sans;
  padding: 15px;
  position: relative;
  cursor: default;

  &__content,
  &__title,
  &__text {
    font-size: 15px !important;
    line-height: 20px !important;
  }

  &__title {
    font-family: Open Sans, sans-serif;
    font-weight: bold;
  }

  &--success {
    background-color: var(--c-sanitas-green);
    color: var(--c-white);
  }

  &--info {
    background-color: var(--c-warm-gray);
    color: var(--c-black);
  }

  &--info-white {
    background-color: var(--c-white);
    color: var(--c-black);
  }

  &--warning {
    background-color: var(--c-yellow);
    color: var(--c-black);
  }

  &--error {
    background-color: var(--c-error);
    color: var(--c-white);
  }

  &__action {
    display: none;
    position: absolute;
    top: 5px;
    right: 5px;
    cursor: pointer;
  }
}

@media (--md) {
  .message {
    &__action {
      display: block;
    }
  }
}
</style>
